import indexMenuPage from '@/views/webpages/index-menu'
import productPurchaseProcessPage from '@/views/webpages/product-purchase-process'
import memberBenefitsPage from '@/views/webpages/member-benefits'
import cartExpenseDescriptionPage from '@/views/webpages/cart-expense-description'
import privacypolicyPage from '@/views/webpages/privacy-policy'
import termsofservicePage from '@/views/webpages/terms-of-service'
import aboutBriefPage from '@/views/webpages/about-brief-in-index'

const indexMenu = {
  path: '/webpage/index/menu',
  name: 'webpage-index-menu',
  component: indexMenuPage
}

const productPurchaseProcess = {
  path: '/webpage/product/purchase-process',
  name: 'webpage-product-purchase-process',
  component: productPurchaseProcessPage
}

const memberBenefits = {
  path: '/webpage/member/benefits',
  name: 'webpage-member-benefits',
  component: memberBenefitsPage
}

const cartExpenseDescription = {
  path: '/webpage/cart/expense-description',
  name: 'webpage-cart-expense-description',
  component: cartExpenseDescriptionPage
}

const privacypolicy = {
  path: '/webpage/privacy-policy/content',
  name: 'webpage-privacypolicy-content',
  component: privacypolicyPage
}

const termsofservice = {
  path: '/webpage/terms-of-service/content',
  name: 'webpage-termsofservice-content',
  component: termsofservicePage
}

const aboutBrief = {
  path: '/webpage/about-brief-in-index/content',
  name: 'webpage-aboutBriefInIndex-content',
  component: aboutBriefPage
}

export default [indexMenu, productPurchaseProcess, memberBenefits, cartExpenseDescription, privacypolicy, termsofservice, aboutBrief]
